import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstallationEdit from '@/ui/pages/InstallationEdit/InstallationEdit';

// HS-1633: a new installation — a new or existing device, a lab's hood, an installer.
export const Route = createFileRoute('/_dashboard/installations/new')({
  beforeLoad: requireRoute('/installations/new'),
  component: InstallationEdit,
});
